import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from 'grommet';
import { localAsset } from '@Helpers/asset';
import { StyledHoverButton, StyledSVG } from './StyledButtons';

const ActionButton = ({
  small,
  label = null,
  iconPath = null,
  icon = null,
  textColor,
  hoverColor = null,
  hoverTextColor,
  actionHandler,
  href = null,
  buttonName = null,
  ...rest
}) => (
  <StyledHoverButton
    plain
    onClick={() => actionHandler()}
    href={href}
    hoverColor={hoverColor}
    textColor={textColor}
    hoverTextColor={hoverTextColor}
    a11yTitle={buttonName ?? label}
    {...rest}
  >
    <Box direction="row" gap="0.5rem" align="center">
      {iconPath && (
        <StyledSVG
          src={localAsset(iconPath)}
          height={small ? '1.1rem' : '1rem'}
          width={small ? '1.1rem' : '1rem'}
          style={{ paddingTop: '0.2rem' }}
          $fillColor={textColor}
        />
      )}
      {icon && (
        <Box style={{ paddingTop: '0.08rem' }}>
          {icon}
        </Box>
      )}
      {label && <Text size="1rem" color={textColor}>{label}</Text>}
    </Box>
  </StyledHoverButton>
);

ActionButton.propTypes = {
  small: PropTypes.bool.isRequired,
  label: PropTypes.string,
  iconPath: PropTypes.string,
  icon: PropTypes.element,
  textColor: PropTypes.string.isRequired,
  hoverTextColor: PropTypes.string,
  hoverColor: PropTypes.string,
  actionHandler: PropTypes.func.isRequired,
  href: PropTypes.string,
  buttonName: PropTypes.string,
};

export default ActionButton;
